<template>
  <div class="row flex-row-reverse balance-summary" style="padding: 0">
    <div class="col-12 col-md-6 col-xxl-4" style="padding: 0">
      <b-table-simple class="resume-table balance-summary" outlined borderless>
        <b-tbody>
          <b-tr>
            <b-th style="width: 1%">
              <b-button :class="shrimpVisible ? null : 'collapsed'" :aria-expanded="shrimpVisible ? 'true' : 'false'" @click="shrimpVisible = !shrimpVisible" style="padding: 0;" variant="link">
                <i v-if="!shrimpVisible" class="text-dark bx bxs-right-arrow"></i>
                <i v-else class="text-dark bx bxs-down-arrow"></i>
              </b-button>
            </b-th>
            <b-th>{{ lodash.startCase($t('sale_notes.resumes.purchased_shrimp')) }}</b-th>
            <b-th style="text-align: right">{{ currencyFormatter(totalPurchasePrice) }}</b-th>
          </b-tr>
          <template v-if="shrimpVisible">
            <b-tr>
              <b-td></b-td>
              <b-th style="padding-left: 24px">{{ lodash.startCase($t('sale_notes.resumes.harvest_fee')) }}</b-th>
              <b-th style="text-align: right">{{ currencyFormatter(totalHarvestPrice) }}</b-th>
            </b-tr>
            <b-tr>
              <b-td></b-td>
              <b-th style="padding-left: 24px">{{ lodash.startCase($t('sale_notes.resumes.additional_fee')) }}</b-th>
              <b-th style="text-align: right">{{ currencyFormatter(totalAdditionalFee) }}</b-th>
            </b-tr>
            <b-tr>
              <b-td></b-td>
              <b-th style="padding-left: 24px">{{ lodash.startCase($t('sale_notes.resumes.discount')) }}</b-th>
              <b-th style="text-align: right">{{ currencyFormatter(totalDiscount) }}</b-th>
            </b-tr>
          </template>
          <b-tr>
            <b-th>
              <b-button :class="saleVisible ? null : 'collapsed'" :aria-expanded="saleVisible ? 'true' : 'false'" @click="saleVisible = !saleVisible" style="padding: 0;" variant="link">
                <i v-if="!saleVisible" class="text-dark bx bxs-right-arrow"></i>
                <i v-else class="text-dark bx bxs-down-arrow"></i>
              </b-button>
            </b-th>
            <b-th>{{ lodash.startCase($t('sale_notes.resumes.sale')) }}</b-th>
            <b-th style="text-align: right">{{ currencyFormatter(totalUnload) }}</b-th>
          </b-tr>
          <template v-if="saleVisible">
            <b-tr>
              <b-td></b-td>
              <b-th style="padding-left: 24px">{{ `Subtotal ${lodash.startCase($t('sale_notes.resumes.sale'))}` }}</b-th>
              <b-th style="text-align: right">{{ currencyFormatter(saleItemTotal) }}</b-th>
            </b-tr>
            <b-tr>
              <b-td></b-td>
              <b-th style="padding-left: 24px">{{ lodash.startCase($t('sale_notes.resumes.diskon')) }}</b-th>
              <b-th style="text-align: right">{{ currencyFormatter(saleAdditionalItemTotal) }}</b-th>
            </b-tr>
            <b-tr v-if="totalOtherOperationalCost !== 0">
              <b-td></b-td>
              <b-th style="padding-left: 24px">{{ lodash.startCase($t('sale_notes.resumes.other')) }}</b-th>
              <b-th style="text-align: right">{{ currencyFormatter(totalOtherOperationalCost) }}</b-th>
            </b-tr>
          </template>
          <b-tr>
            <b-th>
              <b-button :class="operationalCostVisible ? null : 'collapsed'" :aria-expanded="operationalCostVisible ? 'true' : 'false'" @click="operationalCostVisible = !operationalCostVisible" style="padding: 0;" variant="link">
                <i v-if="!operationalCostVisible" class="text-dark bx bxs-right-arrow"></i>
                <i v-else class="text-dark bx bxs-down-arrow"></i>
              </b-button>
            </b-th>
            <b-th>{{ lodash.startCase($t('sale_notes.resumes.operational_fee')) }}</b-th>
            <b-th style="text-align: right">{{ currencyFormatter(totalOperational) }}</b-th>
          </b-tr>
          <template v-if="operationalCostVisible">
            <b-tr>
              <b-td></b-td>
              <b-th style="padding-left: 24px">{{ lodash.startCase($t('sale_notes.resumes.shipping_cost')) }}</b-th>
              <b-th style="text-align: right">{{ currencyFormatter(deliveryCost) }}</b-th>
            </b-tr>
            <b-tr>
              <b-td></b-td>
              <b-th style="padding-left: 24px">{{ lodash.startCase($t('sale_notes.resumes.labour_cost')) }}</b-th>
              <b-th style="text-align: right">{{ currencyFormatter(labourCost) }}</b-th>
            </b-tr>
            <b-tr>
              <b-td></b-td>
              <b-th style="padding-left: 24px">{{ lodash.startCase($t('sale_notes.resumes.glazing')) }}</b-th>
              <b-th style="text-align: right">{{ currencyFormatter(iceCost) }}</b-th>
            </b-tr>
            <b-tr v-if="totalOtherOperationalCost !== 0">
              <b-td></b-td>
              <b-th style="padding-left: 24px">{{ lodash.startCase($t('sale_notes.resumes.other')) }}</b-th>
              <b-th style="text-align: right">{{ currencyFormatter(totalOtherOperationalCost) }}</b-th>
            </b-tr>
          </template>
          <b-tr>
            <b-td></b-td>
            <b-th>{{ lodash.startCase($t('sale_notes.resumes.JALA_margin')) }}</b-th>
            <b-th style="text-align: right">{{ currencyFormatter(jalaMargin) }}</b-th>
          </b-tr>
        </b-tbody>
      </b-table-simple>
    </div>
  </div>
</template>

<script>
export default {
  name: 'summary-card',
  props: {
    value: { type: Object, default: function () { return {} }},
    activeTab: {type: String, default: 'admin'}
  },
  data() {
    return {
      model: this.value,
      saleVisible: true,
      operationalCostVisible: true,
      partnerMarginVisible: true,
      shrimpVisible: true,
    }
  },
  computed: {
    saleItemTotal() {
      return this.value
          .sale_items
          .reduce((carry, {total_price}) => carry + total_price, 0)
    },
    saleAdditionalItemTotal() {
      return this.value.
          sale_additional_items
          .reduce((carry, {total}) => carry + ( total < 0 ? -total : 0), 0)
    },
    iceCost() {
      return -this.value?.sales_reports?.
          filter(({ category, sub_category }) => category.toLowerCase() === 'cost_of_goods_sold' && sub_category === 'ice').
          reduce((carry, { total }) => carry + total, 0) ?? 0
    },
    deliveryCost() {
      return -this.value?.sales_reports?.
          filter(({ category, sub_category }) => category.toLowerCase() === 'expense' && sub_category === 'delivery').
          reduce((carry, { total }) => carry + total, 0) ?? 0
    },
    labourCost() {
      return -this.value?.sales_reports?.
          filter(({ category, sub_category }) => category.toLowerCase() === 'expense' && sub_category === 'labour').
          reduce((carry, { total }) => carry + total, 0) ?? 0
    },
    profitShare() {
      return -this.value?.sales_reports?.
          filter(({ category, sub_category, sales_reportable_type }) => category.toLowerCase() === 'expense' && sub_category === 'general_affairs_cost' && sales_reportable_type === 'App\\Models\\BalancingTransaction').
          reduce((carry, { total }) => carry + total, 0) ?? 0
    },
    partnerMargin() {
      return this.iceCost + this.deliveryCost + this.labourCost + this.profitShare
    },
    jalaMargin() {
      return this.value?.sale_items?.reduce((carry, { margin }) => carry + margin, 0) ?? 0
    },
    accelerationFee() {
      return -this.value?.sale_additional_items?.filter(({ name }) => name.toLowerCase() === 'biaya percepatan').reduce((carry, { total }) => carry + total, 0) ?? 0
    },
    pph() {
      return -this.value?.sale_additional_items?.filter(({ name }) => name.toLowerCase() === 'pph 22').reduce((carry, { total }) => carry + total, 0) ?? 0
    },
    saleItems() {
      return this.value?.sale_items ?? []
    },
    balanceTableItems() {
      return this.model.sale_items.map(({
        shrimp: {name:service_name},
        quality,
        quantity,
        size,
        unit_price,
        total_price,
      }) => ({
        product_name: `vannamei/${this.qualityFormatter(quality)}/${this.lodash.startCase(service_name)}/Size ${size}`,
        quantity: quantity,
        price: unit_price,
        total_price: total_price,
      }))
    },
    totalOtherOperationalCost() {
      return -this.model?.sales_reports?.
          filter(({category, sub_category}) => category.toLowerCase() === 'expense' && sub_category.toLowerCase() === 'other').
          reduce((carry, {total}) => carry + total, 0) ?? 0
    },
    purchaseOrder() {
      return this.value?.trip?.trip_items[0]  ?.purchase_item?.purchase_order ?? {}
    },
    purchaseAdditionalFees() {
      return this.purchaseOrder?.purchase_additional_items?.filter(({total}) => total > 0) ?? []
    },
    purchaseDiscounts() {
      return this.purchaseOrder?.purchase_additional_items?.filter(({total}) => total < 0) ?? []
    },
    totalShrimp() {
      return this.model?.purchase_order?.total ?? 0
    },
    totalUnload() {
      if (this.activeTab.toLowerCase() === 'admin') return this.model?.total ?? 0

      let total = this.value?.sale_items?.reduce((carry, { total_price }) => carry + total_price, 0) ?? 0

      return total + this.pph
    },
    totalAdditionalFee() {
      return this.purchaseAdditionalFees.reduce((carry, {total}) => carry + total, 0)
    },
    totalBiomass() {
      return this.saleItems.reduce((carry, { quantity }) => carry + quantity, 0)
    },
    totalDiscount() {
      return -this.purchaseDiscounts.reduce((carry, {total}) => carry + total, 0)
    },
    totalHarvestPrice() {
      return this.model
          .sale_items
          .reduce((carry, {trip_items}) => carry + trip_items
              .reduce((tripCarry, {purchase_item: {total_price}}) => tripCarry + total_price, 0), 0) ?? 0
    },
    totalPurchasePrice(){
      return this.purchaseOrder?.total ?? 0
    },
    totalPrice() {
      return this.saleItems.reduce((carry, { total_price }) => carry + total_price, 0) ?? 0
    },
    totalSale() {
      return this.model?.total ?? 0
    },
    totalOperational() {
      return this.iceCost + this.deliveryCost + this.labourCost + this.totalOtherOperationalCost
    },
  },
  methods: {
    currencyFormatter(value) {
      return this.$numeral(value).format('$ 0,0.[00]')
    },
    decimalFormatter(value) {
      return this.$numeral(value).format('0,0.[00]')
    },
    qualityFormatter(quality) {
      return ['fresh', 'merah'].includes(quality) ? this.lodash.upperFirst(quality) : this.lodash.upperCase(quality)
    }
  }
}
</script>

<style lang="scss" scoped>
table.balance-summary {
  margin: 0;
  tbody {
    tr:first-child {
      td, th {
        padding-top: 12px !important;
      }
    }
    tr:last-child {
      td, th {
        padding-bottom: 12px !important;
      }
    }
    td, th {
      padding: 4px 8px;
      background-color: #F9FAFB;
    }
  }
}
</style>